/**
 * Shortcut 도메인 Query Hook Wrapper
 */

import {useQuery} from '@tanstack/react-query';
import {SHORTCUT_QUERY_KEY_MAP} from '../api/shortcut/constant';
import {shortcutFactory} from '../factory/shortcutFactory';

// ============================================
// useShortcutListQuery
// ============================================

export function useShortcutListQuery(
  ...args: Parameters<typeof shortcutFactory.shortcutList>
) {
  return useQuery(shortcutFactory.shortcutList(...args));
}

useShortcutListQuery.getKey = (
  ...args: Parameters<typeof SHORTCUT_QUERY_KEY_MAP.shortcutList>
) => [...SHORTCUT_QUERY_KEY_MAP.shortcutList(...args)];
